import React from "react";

const CopyIcon16 = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M13.3337 6H7.33366C6.59699 6 6.00033 6.59667 6.00033 7.33333V13.3333C6.00033 14.07 6.59699 14.6667 7.33366 14.6667H13.3337C14.0703 14.6667 14.667 14.07 14.667 13.3333V7.33333C14.667 6.59667 14.0703 6 13.3337 6Z" stroke="#3A383F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M3.33366 10H2.66699C2.31337 10 1.97423 9.85953 1.72418 9.60948C1.47413 9.35943 1.33366 9.02029 1.33366 8.66667V2.66667C1.33366 2.31304 1.47413 1.97391 1.72418 1.72386C1.97423 1.47381 2.31337 1.33333 2.66699 1.33333H8.66699C9.02061 1.33333 9.35975 1.47381 9.6098 1.72386C9.85985 1.97391 10.0003 2.31304 10.0003 2.66667V3.33333" stroke="#3A383F" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default CopyIcon16;
